import React, { useState } from "react";
import styles from "./styles.module.css";
import { Col, Row } from "react-grid-system";
import { useQuery } from "@tanstack/react-query";
import { GetProducts } from "services/products";
import ReactPaginate from "react-paginate";
import Skeleton from "react-loading-skeleton";
import { ArrowLeft, ArrowRight } from "iconsax-react";
import { Button } from "components";
import useColors from "utils/Colors";

const Pictures = () => {
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(1);
  const [loading, setLoading] = useState(0);

  const Colors = useColors();

  const { data, refetch, isFetching } = useQuery({
    queryKey: ["[List] Product Pictures", page],
    queryFn: () =>
      GetProducts({ page }).then((result) => {
        setPageCount(Math.ceil(result.count / 10));
        return result.results;
      }),
    initialData: [],
  });

  const downloadFile = async (url, fileName) => {
    try {
      const response = await fetch(url, { method: "GET" });
      const blob = await response.blob();
      const urlDownload = window.URL.createObjectURL(blob);
      const link = document.createElement("a");

      link.href = urlDownload;
      link.setAttribute("download", fileName);
      link.click();
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  return (
    <main className={styles.container}>
      <Row gutterWidth={9} style={{ marginBottom: 24 }}>
        {isFetching
          ? [1, 2, 3, 4, 5, 6, 7, 8, 9].map(() => (
              <Col
                xs={4}
                className={`d-flex flex-center`}
                style={{
                  marginBottom: 16,
                }}
              >
                <Skeleton width={120} height={120} />
              </Col>
            ))
          : data.map((pr) => (
              <Col
                xs={4}
                className={`d-flex flex-center ${styles.product_col}`}
              >
                {loading == pr.internal_code ? (
                  <Skeleton width={120} height={120} />
                ) : (
                  <div
                    onClick={() => {
                      setLoading(pr.internal_code);
                      downloadFile(
                        pr?.featured_image?.file,
                        `${pr.internal_code}.png`
                      );
                    }}
                    style={{
                      width: "100%",
                      aspectRatio: "1 / 1",
                      border: "1px solid #c1c1c1",
                      borderRadius: 10,
                      marginBottom: 16,
                      overflow: "hidden",
                    }}
                  >
                    <img
                      src={pr?.featured_image?.file}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                )}
              </Col>
            ))}
      </Row>
      <div
        className="d-flex align-items-center justify-content-between"
        style={{ gap: 8 }}
      >
        <Button
          type={"primary"}
          ghost={true}
          disabled={page == pageCount}
          onClick={() => page + 1 <= pageCount && setPage(page + 1)}
          style={{ width: "fit-content" }}
        >
          <ArrowRight size={20} color={Colors.Primary[3]} />
        </Button>
        {page}
        <Button
          type={"primary"}
          ghost={true}
          onClick={() => page - 1 > 0 && setPage(page - 1)}
          style={{ width: "fit-content" }}
          disabled={page == 1}
        >
          <ArrowLeft size={20} color={Colors.Primary[3]} />
        </Button>
      </div>
    </main>
  );
};

export default Pictures;
